import React from 'react';
import PrinterSelectionModal from '../shared/components/PrinterSelectionModal';
import BridgeInstallModal from '../shared/components/BridgeInstallModal';
import BarcodeScanner from '../../../components/BarcodeScanner';
import ForcePrintDialog from './ForcePrintDialog';

const NfeModals = ({
  printerModalOpen,
  setPrinterModalOpen,
  availablePrinters,
  selectedPrinter,
  loadingPrinters,
  handleSelectPrinter,
  detectPrinters,
  autoPrintEnabled,
  bridgeInstallModalOpen,
  setBridgeInstallModalOpen,
  downloadProgress,
  downloadBridgeInstaller,
  scannerOpen,
  handleCloseScanner,
  handleScanResult,
  showForceDialog,
  handleCloseForceDialog,
  handleConfirmForceDialog,
}) => {
  return (
    <>
      <PrinterSelectionModal
        open={printerModalOpen}
        onClose={() => setPrinterModalOpen(false)}
        availablePrinters={availablePrinters}
        selectedPrinter={selectedPrinter}
        loadingPrinters={loadingPrinters}
        onSelectPrinter={handleSelectPrinter}
        onDetectPrinters={detectPrinters}
        autoPrintEnabled={autoPrintEnabled}
      />

      <BridgeInstallModal
        open={bridgeInstallModalOpen}
        onClose={() => setBridgeInstallModalOpen(false)}
        downloadProgress={downloadProgress}
        onDownload={downloadBridgeInstaller}
      />

      <BarcodeScanner
        open={scannerOpen}
        onClose={handleCloseScanner}
        onScan={handleScanResult}
      />

      <ForcePrintDialog
        open={showForceDialog}
        onCancel={handleCloseForceDialog}
        onConfirm={handleConfirmForceDialog}
      />
    </>
  );
};

export default NfeModals;